import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../../../Hooks/stateProvider";
import { ls } from "../../../../variables";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CommentDialogBox from "../../../CommonLayouts/CommentDialogBox";
import Styles from "../../Styles/main.module.css";
import ViewCard from "../../../../components/ViewCard";
import { encrypt } from "../../../../utils/cipher";
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";

function View() {
  const [{ moduleType }, dispatch] = useStateValue();

  const userType = ls.get("userType");
  const navigate = useNavigate();

  // const [personName, setPersonName] = React.useState([]);
  const [rows, setRows] = useState([]);
  const [complianceType, setComplianceType] = useState("");
  // const [compliancePercent, setCompliancePercent] = useState("");
  const [open, setOpen] = useState(false);
  const [receivedStatus, setReceivedStatus] = useState("");
  const location = useLocation();


  const handleClickOpen = () => {
    setOpen(true);
  };
  const data = location.state;
  const pmsName = ls.get("pmsName");

  const cmmViewPayload = {
    fy_year: data.fy_year,
    quarter: data.quarter,
    pmsName: pmsName,
    particulars: data.particulars,
    moduleType: "CMM",
    authToken: ls.get("authToken"),
    refreshToken: ls.get("refreshToken")
  };

  const viewPageFetch = async () => {
    try {
      if (location.pathname == "/app/cmmView") {
        let encryptedPayload = await encrypt(cmmViewPayload)
        const response = await axios.post(
          "/api/pms/viewPageFetchAPI",
          { payload: encryptedPayload }
        );

        dispatch({ type: "fileName", fileName: "" })
        setComplianceType(response?.data.data.compliance_status);
        setRows(response?.data.data.cmm_remarks);
        setReceivedStatus(response?.data.data.cmm_status);
      } 
    }
    catch (err) {
      errorHandler(err, navigate)
    }
  };

  useEffect(() => {
    viewPageFetch();
  }, []);

  const downloadReport = async (uploadS3FilePath, filename) => {
    console.log("uploadS3FilePath",uploadS3FilePath, filename);
    
    try {
      if (uploadS3FilePath == undefined || uploadS3FilePath == "") {
        alert("Sorry!!", "No File Found", "error")
        return;
      }
      const downloadPayload = {
        s3Location: uploadS3FilePath,
        moduleType: data.moduleType,
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken"),
        filename
      };
      let encryptedPayload = await encrypt(downloadPayload)
      const result = axios.post("/api/pms/downloadReport", { payload: encryptedPayload });
      result.then((response) => {
        if (response.data.success) {
          window.open(response.data.data, "_self");
        }
      });
    }
    catch (err) {
      errorHandler(err, navigate)
    }

  };

  return (<>
    <div className={Styles.FullBody} style={{ overflowY: "auto" }}>
      <div className={Styles.navBody}>
        <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
          <Link
            underline="hover"
            color="inherit"
            onClick={() => navigate("/app/welcome")}
          >
            Welcome
          </Link>
          <Link
            underline="hover"
            color="inherit"
            onClick={() => {
              dispatch({ type: "SET_filter", setFilter: false });
              if (moduleType == "CMM") navigate("/app/cmmTracker");
              else navigate("");
            }}
          >
            {"Tracker"}
          </Link>
          <Link
            underline="hover"
            color="inherit"
          // onClick={() => navigate("/app/takeAction")}
          >
            View
          </Link>
          {/* <Typography color="text.primary" fontWeight="bold">Current</Typography> */}
        </Breadcrumbs>
      </div>
      <div
        className={Styles.HeaderBody}
        style={{ marginTop: "1%", height: "max-content" }}
      >
        <Grid
          container
          spacing={0}
          display="flex"
          lg={12}
          justifyContent={"start"}
          gap={"0.5rem"}
          alignContent={"start"}
          height={{
            xs: "max-content",
            lg: "max-content",
            md: "max-content",
            sm: "max-content",
          }}
          padding={"0.5rem"}
        >
          {moduleType == "CMM" ? (
            <>
              <Grid container
                // spacing={2} 
                columns={12} 
                gap={2}
                height={{
                  lg: "auto",
                  sm: "max-content",
                  xs: "max-content",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={5.8}
                  className={Styles.gridBox}
                 
                >
                  <ViewCard
                    cardHeader={"Particulars"}
                    cardContent={data.particulars}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={5.8}
                  className={Styles.gridBox}
                >
                  <ViewCard
                    cardHeader={"Compliance Type"}
                    cardContent={complianceType}
                  />
                </Grid>
              </Grid>

            </>
          ) : ''}
        </Grid>
        <Box
          style={{
            overflowY: "auto",
            height: "35vh",
            width: "100%",
            marginTop: "1%",
          }}
        >
          <Grid xs={11.8} padding={"0.2rem"}>
            {rows?.map((val, index) => (
              (<Grid
                container
                style={{
                  backgroundImage: "linear-gradient(#d4e4f2,#f0f0f0)",

                  boxShadow: " 0 2px 4px 0 rgba(0, 0, 0, 0.2) ",
                  padding: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  marginTop: "0.5rem",
                  width: "100%",
                  borderRadius: "1rem",
                  // height: "3rem",
                }}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <p
                    style={{
                      fontWeight: "bold",
                      color: "#154063",
                      margin: 0,
                      fontSize: "0.8rem"
                    }}
                  >
                    {val.date}
                  </p>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={2}
                  md={1.5}
                  lg={1.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {val.pms_comments || val.pms_comments == "" ? (
                    <p style={{ fontWeight: "bold", color: "#154063" }}>
                      PMS Comments
                    </p>
                  ) : val.sebi_comments || val.sebi_comments == "" ? (
                    <p style={{ fontWeight: "bold", color: "#154063" }}>
                      SEBI Comments
                    </p>
                  ) : ''
                  }
                </Grid>
                <Grid
                  item
                  xs={8}
                  sm={10}
                  md={10.5}
                  lg={8.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{
                    width: "96%",
                    borderRadius: "0.5rem ",
                    border: "0px",
                    backgroundColor: "#FFFFFF",
                    resize: "none",
                    overflowY: "auto",
                    padding: "5px",
                    minHeight: "2rem",
                    maxHeight: "10rem",
                    whiteSpace: "pre-wrap"
                  }}>
                   {val.pms_comments ? val.pms_comments : val.sebi_comments}
                  </div>
                </Grid>
                <Grid
                  item
                  md={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className={Styles.Preview}
                    key={index}
                    style={{
                      backgroundColor: val.s3Location == undefined || val.s3Location == "" ? "#808080" : "#154063", cursor: val.s3Location == undefined || val.s3Location == "" ? "initial" : "pointer",
                      border: val.s3Location == undefined || val.s3Location == "" ? "0.125rem solid #808080" : "0.125rem solid #154063",
                    }}
                    disabled={val.s3Location == undefined || val.s3Location == "" ? true : false}
                    onClick={() => {
                      downloadReport(val.s3Location, val.uploadedfileName);
                    }}
                  >
                    DOWNLOAD
                  </button>
                </Grid>
              </Grid>)
            ))}
          </Grid>
        </Box>
        <Grid container sx={{ display: "flex" }}>
          <Grid
            item
            xs={12}
            lg={12}
            sx={{ textAlign: "center", padding: "1%" }}
          >
            <button onClick={handleClickOpen} className={Styles.Preview}
              style={{
                backgroundColor: ((userType == "PMS" && rows[rows?.length - 1]?.pms_comments != undefined) || receivedStatus == "closed") ? "#808080" : "#154063",
                border: ((userType == "PMS" && rows[rows?.length - 1]?.pms_comments != undefined) || receivedStatus == "closed") ? "#808080" : "#154063"
              }}
            disabled={((userType == "PMS" && rows[rows?.length - 1]?.pms_comments != undefined) || receivedStatus == "closed") ? true : false}>
            ADD COMMENT
          </button>
          {open && (
            <CommentDialogBox
              userType={userType}
              open={open}
              setOpen={setOpen}
              fetchData={viewPageFetch}
              onClose={() => setOpen(false)}
            />
          )}
        </Grid>
      </Grid>
    </div>
  </div >
  </>);
}

export default View;
